/**
 * WebGL constant value definitions
 */ var WebGLEnum = /*#__PURE__*/ function(WebGLEnum) {
    WebGLEnum[WebGLEnum["READ_BUFFER"] = 3074] = "READ_BUFFER";
    WebGLEnum[WebGLEnum["UNPACK_ROW_LENGTH"] = 3314] = "UNPACK_ROW_LENGTH";
    WebGLEnum[WebGLEnum["UNPACK_SKIP_ROWS"] = 3315] = "UNPACK_SKIP_ROWS";
    WebGLEnum[WebGLEnum["UNPACK_SKIP_PIXELS"] = 3316] = "UNPACK_SKIP_PIXELS";
    WebGLEnum[WebGLEnum["PACK_ROW_LENGTH"] = 3330] = "PACK_ROW_LENGTH";
    WebGLEnum[WebGLEnum["PACK_SKIP_ROWS"] = 3331] = "PACK_SKIP_ROWS";
    WebGLEnum[WebGLEnum["PACK_SKIP_PIXELS"] = 3332] = "PACK_SKIP_PIXELS";
    WebGLEnum[WebGLEnum["COLOR"] = 6144] = "COLOR";
    WebGLEnum[WebGLEnum["DEPTH"] = 6145] = "DEPTH";
    WebGLEnum[WebGLEnum["STENCIL"] = 6146] = "STENCIL";
    WebGLEnum[WebGLEnum["RED"] = 6403] = "RED";
    WebGLEnum[WebGLEnum["RGB8"] = 32849] = "RGB8";
    WebGLEnum[WebGLEnum["RGBA8"] = 32856] = "RGBA8";
    WebGLEnum[WebGLEnum["RGB10_A2"] = 32857] = "RGB10_A2";
    WebGLEnum[WebGLEnum["TEXTURE_BINDING_3D"] = 32874] = "TEXTURE_BINDING_3D";
    WebGLEnum[WebGLEnum["UNPACK_SKIP_IMAGES"] = 32877] = "UNPACK_SKIP_IMAGES";
    WebGLEnum[WebGLEnum["UNPACK_IMAGE_HEIGHT"] = 32878] = "UNPACK_IMAGE_HEIGHT";
    WebGLEnum[WebGLEnum["TEXTURE_3D"] = 32879] = "TEXTURE_3D";
    WebGLEnum[WebGLEnum["TEXTURE_WRAP_R"] = 32882] = "TEXTURE_WRAP_R";
    WebGLEnum[WebGLEnum["MAX_3D_TEXTURE_SIZE"] = 32883] = "MAX_3D_TEXTURE_SIZE";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    WebGLEnum[WebGLEnum["MAX_ELEMENTS_VERTICES"] = 33000] = "MAX_ELEMENTS_VERTICES";
    WebGLEnum[WebGLEnum["MAX_ELEMENTS_INDICES"] = 33001] = "MAX_ELEMENTS_INDICES";
    WebGLEnum[WebGLEnum["TEXTURE_MIN_LOD"] = 33082] = "TEXTURE_MIN_LOD";
    WebGLEnum[WebGLEnum["TEXTURE_MAX_LOD"] = 33083] = "TEXTURE_MAX_LOD";
    WebGLEnum[WebGLEnum["TEXTURE_BASE_LEVEL"] = 33084] = "TEXTURE_BASE_LEVEL";
    WebGLEnum[WebGLEnum["TEXTURE_MAX_LEVEL"] = 33085] = "TEXTURE_MAX_LEVEL";
    WebGLEnum[WebGLEnum["MIN"] = 32775] = "MIN";
    WebGLEnum[WebGLEnum["MAX"] = 32776] = "MAX";
    WebGLEnum[WebGLEnum["DEPTH_COMPONENT24"] = 33190] = "DEPTH_COMPONENT24";
    WebGLEnum[WebGLEnum["MAX_TEXTURE_LOD_BIAS"] = 34045] = "MAX_TEXTURE_LOD_BIAS";
    WebGLEnum[WebGLEnum["TEXTURE_COMPARE_MODE"] = 34892] = "TEXTURE_COMPARE_MODE";
    WebGLEnum[WebGLEnum["TEXTURE_COMPARE_FUNC"] = 34893] = "TEXTURE_COMPARE_FUNC";
    WebGLEnum[WebGLEnum["CURRENT_QUERY"] = 34917] = "CURRENT_QUERY";
    WebGLEnum[WebGLEnum["QUERY_RESULT"] = 34918] = "QUERY_RESULT";
    WebGLEnum[WebGLEnum["QUERY_RESULT_AVAILABLE"] = 34919] = "QUERY_RESULT_AVAILABLE";
    WebGLEnum[WebGLEnum["STREAM_READ"] = 35041] = "STREAM_READ";
    WebGLEnum[WebGLEnum["STREAM_COPY"] = 35042] = "STREAM_COPY";
    WebGLEnum[WebGLEnum["STATIC_READ"] = 35045] = "STATIC_READ";
    WebGLEnum[WebGLEnum["STATIC_COPY"] = 35046] = "STATIC_COPY";
    WebGLEnum[WebGLEnum["DYNAMIC_READ"] = 35049] = "DYNAMIC_READ";
    WebGLEnum[WebGLEnum["DYNAMIC_COPY"] = 35050] = "DYNAMIC_COPY";
    WebGLEnum[WebGLEnum["MAX_DRAW_BUFFERS"] = 34852] = "MAX_DRAW_BUFFERS";
    WebGLEnum[WebGLEnum["DRAW_BUFFER0"] = 34853] = "DRAW_BUFFER0";
    WebGLEnum[WebGLEnum["DRAW_BUFFER1"] = 34854] = "DRAW_BUFFER1";
    WebGLEnum[WebGLEnum["DRAW_BUFFER2"] = 34855] = "DRAW_BUFFER2";
    WebGLEnum[WebGLEnum["DRAW_BUFFER3"] = 34856] = "DRAW_BUFFER3";
    WebGLEnum[WebGLEnum["DRAW_BUFFER4"] = 34857] = "DRAW_BUFFER4";
    WebGLEnum[WebGLEnum["DRAW_BUFFER5"] = 34858] = "DRAW_BUFFER5";
    WebGLEnum[WebGLEnum["DRAW_BUFFER6"] = 34859] = "DRAW_BUFFER6";
    WebGLEnum[WebGLEnum["DRAW_BUFFER7"] = 34860] = "DRAW_BUFFER7";
    WebGLEnum[WebGLEnum["DRAW_BUFFER8"] = 34861] = "DRAW_BUFFER8";
    WebGLEnum[WebGLEnum["DRAW_BUFFER9"] = 34862] = "DRAW_BUFFER9";
    WebGLEnum[WebGLEnum["DRAW_BUFFER10"] = 34863] = "DRAW_BUFFER10";
    WebGLEnum[WebGLEnum["DRAW_BUFFER11"] = 34864] = "DRAW_BUFFER11";
    WebGLEnum[WebGLEnum["DRAW_BUFFER12"] = 34865] = "DRAW_BUFFER12";
    WebGLEnum[WebGLEnum["DRAW_BUFFER13"] = 34866] = "DRAW_BUFFER13";
    WebGLEnum[WebGLEnum["DRAW_BUFFER14"] = 34867] = "DRAW_BUFFER14";
    WebGLEnum[WebGLEnum["DRAW_BUFFER15"] = 34868] = "DRAW_BUFFER15";
    WebGLEnum[WebGLEnum["MAX_FRAGMENT_UNIFORM_COMPONENTS"] = 35657] = "MAX_FRAGMENT_UNIFORM_COMPONENTS";
    WebGLEnum[WebGLEnum["MAX_VERTEX_UNIFORM_COMPONENTS"] = 35658] = "MAX_VERTEX_UNIFORM_COMPONENTS";
    WebGLEnum[WebGLEnum["SAMPLER_3D"] = 35679] = "SAMPLER_3D";
    WebGLEnum[WebGLEnum["SAMPLER_2D_SHADOW"] = 35682] = "SAMPLER_2D_SHADOW";
    WebGLEnum[WebGLEnum["FRAGMENT_SHADER_DERIVATIVE_HINT"] = 35723] = "FRAGMENT_SHADER_DERIVATIVE_HINT";
    WebGLEnum[WebGLEnum["PIXEL_PACK_BUFFER"] = 35051] = "PIXEL_PACK_BUFFER";
    WebGLEnum[WebGLEnum["PIXEL_UNPACK_BUFFER"] = 35052] = "PIXEL_UNPACK_BUFFER";
    WebGLEnum[WebGLEnum["PIXEL_PACK_BUFFER_BINDING"] = 35053] = "PIXEL_PACK_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["PIXEL_UNPACK_BUFFER_BINDING"] = 35055] = "PIXEL_UNPACK_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["FLOAT_MAT2x3"] = 35685] = "FLOAT_MAT2x3";
    WebGLEnum[WebGLEnum["FLOAT_MAT2x4"] = 35686] = "FLOAT_MAT2x4";
    WebGLEnum[WebGLEnum["FLOAT_MAT3x2"] = 35687] = "FLOAT_MAT3x2";
    WebGLEnum[WebGLEnum["FLOAT_MAT3x4"] = 35688] = "FLOAT_MAT3x4";
    WebGLEnum[WebGLEnum["FLOAT_MAT4x2"] = 35689] = "FLOAT_MAT4x2";
    WebGLEnum[WebGLEnum["FLOAT_MAT4x3"] = 35690] = "FLOAT_MAT4x3";
    WebGLEnum[WebGLEnum["SRGB"] = 35904] = "SRGB";
    WebGLEnum[WebGLEnum["SRGB8"] = 35905] = "SRGB8";
    WebGLEnum[WebGLEnum["SRGB_ALPHA"] = 35906] = "SRGB_ALPHA";
    WebGLEnum[WebGLEnum["SRGB8_ALPHA8"] = 35907] = "SRGB8_ALPHA8";
    WebGLEnum[WebGLEnum["COMPARE_REF_TO_TEXTURE"] = 34894] = "COMPARE_REF_TO_TEXTURE";
    WebGLEnum[WebGLEnum["RGBA32F"] = 34836] = "RGBA32F";
    WebGLEnum[WebGLEnum["RGB32F"] = 34837] = "RGB32F";
    WebGLEnum[WebGLEnum["RGBA16F"] = 34842] = "RGBA16F";
    WebGLEnum[WebGLEnum["RGB16F"] = 34843] = "RGB16F";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_INTEGER"] = 35069] = "VERTEX_ATTRIB_ARRAY_INTEGER";
    WebGLEnum[WebGLEnum["MAX_ARRAY_TEXTURE_LAYERS"] = 35071] = "MAX_ARRAY_TEXTURE_LAYERS";
    WebGLEnum[WebGLEnum["MIN_PROGRAM_TEXEL_OFFSET"] = 35076] = "MIN_PROGRAM_TEXEL_OFFSET";
    WebGLEnum[WebGLEnum["MAX_PROGRAM_TEXEL_OFFSET"] = 35077] = "MAX_PROGRAM_TEXEL_OFFSET";
    WebGLEnum[WebGLEnum["MAX_VARYING_COMPONENTS"] = 35659] = "MAX_VARYING_COMPONENTS";
    WebGLEnum[WebGLEnum["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    WebGLEnum[WebGLEnum["TEXTURE_BINDING_2D_ARRAY"] = 35869] = "TEXTURE_BINDING_2D_ARRAY";
    WebGLEnum[WebGLEnum["R11F_G11F_B10F"] = 35898] = "R11F_G11F_B10F";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    WebGLEnum[WebGLEnum["RGB9_E5"] = 35901] = "RGB9_E5";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_BUFFER_MODE"] = 35967] = "TRANSFORM_FEEDBACK_BUFFER_MODE";
    WebGLEnum[WebGLEnum["MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS"] = 35968] = "MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_VARYINGS"] = 35971] = "TRANSFORM_FEEDBACK_VARYINGS";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_BUFFER_START"] = 35972] = "TRANSFORM_FEEDBACK_BUFFER_START";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_BUFFER_SIZE"] = 35973] = "TRANSFORM_FEEDBACK_BUFFER_SIZE";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN"] = 35976] = "TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN";
    WebGLEnum[WebGLEnum["RASTERIZER_DISCARD"] = 35977] = "RASTERIZER_DISCARD";
    WebGLEnum[WebGLEnum["MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS"] = 35978] = "MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS";
    WebGLEnum[WebGLEnum["MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS"] = 35979] = "MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS";
    WebGLEnum[WebGLEnum["INTERLEAVED_ATTRIBS"] = 35980] = "INTERLEAVED_ATTRIBS";
    WebGLEnum[WebGLEnum["SEPARATE_ATTRIBS"] = 35981] = "SEPARATE_ATTRIBS";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_BUFFER"] = 35982] = "TRANSFORM_FEEDBACK_BUFFER";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_BUFFER_BINDING"] = 35983] = "TRANSFORM_FEEDBACK_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["RGBA32UI"] = 36208] = "RGBA32UI";
    WebGLEnum[WebGLEnum["RGB32UI"] = 36209] = "RGB32UI";
    WebGLEnum[WebGLEnum["RGBA16UI"] = 36214] = "RGBA16UI";
    WebGLEnum[WebGLEnum["RGB16UI"] = 36215] = "RGB16UI";
    WebGLEnum[WebGLEnum["RGBA8UI"] = 36220] = "RGBA8UI";
    WebGLEnum[WebGLEnum["RGB8UI"] = 36221] = "RGB8UI";
    WebGLEnum[WebGLEnum["RGBA32I"] = 36226] = "RGBA32I";
    WebGLEnum[WebGLEnum["RGB32I"] = 36227] = "RGB32I";
    WebGLEnum[WebGLEnum["RGBA16I"] = 36232] = "RGBA16I";
    WebGLEnum[WebGLEnum["RGB16I"] = 36233] = "RGB16I";
    WebGLEnum[WebGLEnum["RGBA8I"] = 36238] = "RGBA8I";
    WebGLEnum[WebGLEnum["RGB8I"] = 36239] = "RGB8I";
    WebGLEnum[WebGLEnum["RED_INTEGER"] = 36244] = "RED_INTEGER";
    WebGLEnum[WebGLEnum["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    WebGLEnum[WebGLEnum["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    WebGLEnum[WebGLEnum["SAMPLER_2D_ARRAY"] = 36289] = "SAMPLER_2D_ARRAY";
    WebGLEnum[WebGLEnum["SAMPLER_2D_ARRAY_SHADOW"] = 36292] = "SAMPLER_2D_ARRAY_SHADOW";
    WebGLEnum[WebGLEnum["SAMPLER_CUBE_SHADOW"] = 36293] = "SAMPLER_CUBE_SHADOW";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_VEC2"] = 36294] = "UNSIGNED_INT_VEC2";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_VEC3"] = 36295] = "UNSIGNED_INT_VEC3";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_VEC4"] = 36296] = "UNSIGNED_INT_VEC4";
    WebGLEnum[WebGLEnum["INT_SAMPLER_2D"] = 36298] = "INT_SAMPLER_2D";
    WebGLEnum[WebGLEnum["INT_SAMPLER_3D"] = 36299] = "INT_SAMPLER_3D";
    WebGLEnum[WebGLEnum["INT_SAMPLER_CUBE"] = 36300] = "INT_SAMPLER_CUBE";
    WebGLEnum[WebGLEnum["INT_SAMPLER_2D_ARRAY"] = 36303] = "INT_SAMPLER_2D_ARRAY";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_SAMPLER_2D"] = 36306] = "UNSIGNED_INT_SAMPLER_2D";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_SAMPLER_3D"] = 36307] = "UNSIGNED_INT_SAMPLER_3D";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_SAMPLER_CUBE"] = 36308] = "UNSIGNED_INT_SAMPLER_CUBE";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_SAMPLER_2D_ARRAY"] = 36311] = "UNSIGNED_INT_SAMPLER_2D_ARRAY";
    WebGLEnum[WebGLEnum["DEPTH_COMPONENT32F"] = 36012] = "DEPTH_COMPONENT32F";
    WebGLEnum[WebGLEnum["DEPTH32F_STENCIL8"] = 36013] = "DEPTH32F_STENCIL8";
    WebGLEnum[WebGLEnum["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING"] = 33296] = "FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE"] = 33297] = "FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_RED_SIZE"] = 33298] = "FRAMEBUFFER_ATTACHMENT_RED_SIZE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_GREEN_SIZE"] = 33299] = "FRAMEBUFFER_ATTACHMENT_GREEN_SIZE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_BLUE_SIZE"] = 33300] = "FRAMEBUFFER_ATTACHMENT_BLUE_SIZE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE"] = 33301] = "FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE"] = 33302] = "FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE"] = 33303] = "FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_DEFAULT"] = 33304] = "FRAMEBUFFER_DEFAULT";
    WebGLEnum[WebGLEnum["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    WebGLEnum[WebGLEnum["DEPTH24_STENCIL8"] = 35056] = "DEPTH24_STENCIL8";
    WebGLEnum[WebGLEnum["UNSIGNED_NORMALIZED"] = 35863] = "UNSIGNED_NORMALIZED";
    WebGLEnum[WebGLEnum["DRAW_FRAMEBUFFER_BINDING"] = 36006] = "DRAW_FRAMEBUFFER_BINDING";
    WebGLEnum[WebGLEnum["READ_FRAMEBUFFER"] = 36008] = "READ_FRAMEBUFFER";
    WebGLEnum[WebGLEnum["DRAW_FRAMEBUFFER"] = 36009] = "DRAW_FRAMEBUFFER";
    WebGLEnum[WebGLEnum["READ_FRAMEBUFFER_BINDING"] = 36010] = "READ_FRAMEBUFFER_BINDING";
    WebGLEnum[WebGLEnum["RENDERBUFFER_SAMPLES"] = 36011] = "RENDERBUFFER_SAMPLES";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER"] = 36052] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER";
    WebGLEnum[WebGLEnum["MAX_COLOR_ATTACHMENTS"] = 36063] = "MAX_COLOR_ATTACHMENTS";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT1"] = 36065] = "COLOR_ATTACHMENT1";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT2"] = 36066] = "COLOR_ATTACHMENT2";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT3"] = 36067] = "COLOR_ATTACHMENT3";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT4"] = 36068] = "COLOR_ATTACHMENT4";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT5"] = 36069] = "COLOR_ATTACHMENT5";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT6"] = 36070] = "COLOR_ATTACHMENT6";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT7"] = 36071] = "COLOR_ATTACHMENT7";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT8"] = 36072] = "COLOR_ATTACHMENT8";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT9"] = 36073] = "COLOR_ATTACHMENT9";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT10"] = 36074] = "COLOR_ATTACHMENT10";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT11"] = 36075] = "COLOR_ATTACHMENT11";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT12"] = 36076] = "COLOR_ATTACHMENT12";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT13"] = 36077] = "COLOR_ATTACHMENT13";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT14"] = 36078] = "COLOR_ATTACHMENT14";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT15"] = 36079] = "COLOR_ATTACHMENT15";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_INCOMPLETE_MULTISAMPLE"] = 36182] = "FRAMEBUFFER_INCOMPLETE_MULTISAMPLE";
    WebGLEnum[WebGLEnum["MAX_SAMPLES"] = 36183] = "MAX_SAMPLES";
    WebGLEnum[WebGLEnum["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
    WebGLEnum[WebGLEnum["RG"] = 33319] = "RG";
    WebGLEnum[WebGLEnum["RG_INTEGER"] = 33320] = "RG_INTEGER";
    WebGLEnum[WebGLEnum["R8"] = 33321] = "R8";
    WebGLEnum[WebGLEnum["RG8"] = 33323] = "RG8";
    WebGLEnum[WebGLEnum["R16F"] = 33325] = "R16F";
    WebGLEnum[WebGLEnum["R32F"] = 33326] = "R32F";
    WebGLEnum[WebGLEnum["RG16F"] = 33327] = "RG16F";
    WebGLEnum[WebGLEnum["RG32F"] = 33328] = "RG32F";
    WebGLEnum[WebGLEnum["R8I"] = 33329] = "R8I";
    WebGLEnum[WebGLEnum["R8UI"] = 33330] = "R8UI";
    WebGLEnum[WebGLEnum["R16I"] = 33331] = "R16I";
    WebGLEnum[WebGLEnum["R16UI"] = 33332] = "R16UI";
    WebGLEnum[WebGLEnum["R32I"] = 33333] = "R32I";
    WebGLEnum[WebGLEnum["R32UI"] = 33334] = "R32UI";
    WebGLEnum[WebGLEnum["RG8I"] = 33335] = "RG8I";
    WebGLEnum[WebGLEnum["RG8UI"] = 33336] = "RG8UI";
    WebGLEnum[WebGLEnum["RG16I"] = 33337] = "RG16I";
    WebGLEnum[WebGLEnum["RG16UI"] = 33338] = "RG16UI";
    WebGLEnum[WebGLEnum["RG32I"] = 33339] = "RG32I";
    WebGLEnum[WebGLEnum["RG32UI"] = 33340] = "RG32UI";
    WebGLEnum[WebGLEnum["VERTEX_ARRAY_BINDING"] = 34229] = "VERTEX_ARRAY_BINDING";
    WebGLEnum[WebGLEnum["R8_SNORM"] = 36756] = "R8_SNORM";
    WebGLEnum[WebGLEnum["RG8_SNORM"] = 36757] = "RG8_SNORM";
    WebGLEnum[WebGLEnum["RGB8_SNORM"] = 36758] = "RGB8_SNORM";
    WebGLEnum[WebGLEnum["RGBA8_SNORM"] = 36759] = "RGBA8_SNORM";
    WebGLEnum[WebGLEnum["SIGNED_NORMALIZED"] = 36764] = "SIGNED_NORMALIZED";
    WebGLEnum[WebGLEnum["COPY_READ_BUFFER"] = 36662] = "COPY_READ_BUFFER";
    WebGLEnum[WebGLEnum["COPY_WRITE_BUFFER"] = 36663] = "COPY_WRITE_BUFFER";
    WebGLEnum[WebGLEnum["COPY_READ_BUFFER_BINDING"] = 36662] = "COPY_READ_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["COPY_WRITE_BUFFER_BINDING"] = 36663] = "COPY_WRITE_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
    WebGLEnum[WebGLEnum["UNIFORM_BUFFER_BINDING"] = 35368] = "UNIFORM_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["UNIFORM_BUFFER_START"] = 35369] = "UNIFORM_BUFFER_START";
    WebGLEnum[WebGLEnum["UNIFORM_BUFFER_SIZE"] = 35370] = "UNIFORM_BUFFER_SIZE";
    WebGLEnum[WebGLEnum["MAX_VERTEX_UNIFORM_BLOCKS"] = 35371] = "MAX_VERTEX_UNIFORM_BLOCKS";
    WebGLEnum[WebGLEnum["MAX_FRAGMENT_UNIFORM_BLOCKS"] = 35373] = "MAX_FRAGMENT_UNIFORM_BLOCKS";
    WebGLEnum[WebGLEnum["MAX_COMBINED_UNIFORM_BLOCKS"] = 35374] = "MAX_COMBINED_UNIFORM_BLOCKS";
    WebGLEnum[WebGLEnum["MAX_UNIFORM_BUFFER_BINDINGS"] = 35375] = "MAX_UNIFORM_BUFFER_BINDINGS";
    WebGLEnum[WebGLEnum["MAX_UNIFORM_BLOCK_SIZE"] = 35376] = "MAX_UNIFORM_BLOCK_SIZE";
    WebGLEnum[WebGLEnum["MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS"] = 35377] = "MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS";
    WebGLEnum[WebGLEnum["MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS"] = 35379] = "MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS";
    WebGLEnum[WebGLEnum["UNIFORM_BUFFER_OFFSET_ALIGNMENT"] = 35380] = "UNIFORM_BUFFER_OFFSET_ALIGNMENT";
    WebGLEnum[WebGLEnum["ACTIVE_UNIFORM_BLOCKS"] = 35382] = "ACTIVE_UNIFORM_BLOCKS";
    WebGLEnum[WebGLEnum["UNIFORM_TYPE"] = 35383] = "UNIFORM_TYPE";
    WebGLEnum[WebGLEnum["UNIFORM_SIZE"] = 35384] = "UNIFORM_SIZE";
    WebGLEnum[WebGLEnum["UNIFORM_BLOCK_INDEX"] = 35386] = "UNIFORM_BLOCK_INDEX";
    WebGLEnum[WebGLEnum["UNIFORM_OFFSET"] = 35387] = "UNIFORM_OFFSET";
    WebGLEnum[WebGLEnum["UNIFORM_ARRAY_STRIDE"] = 35388] = "UNIFORM_ARRAY_STRIDE";
    WebGLEnum[WebGLEnum["UNIFORM_MATRIX_STRIDE"] = 35389] = "UNIFORM_MATRIX_STRIDE";
    WebGLEnum[WebGLEnum["UNIFORM_IS_ROW_MAJOR"] = 35390] = "UNIFORM_IS_ROW_MAJOR";
    WebGLEnum[WebGLEnum["UNIFORM_BLOCK_BINDING"] = 35391] = "UNIFORM_BLOCK_BINDING";
    WebGLEnum[WebGLEnum["UNIFORM_BLOCK_DATA_SIZE"] = 35392] = "UNIFORM_BLOCK_DATA_SIZE";
    WebGLEnum[WebGLEnum["UNIFORM_BLOCK_ACTIVE_UNIFORMS"] = 35394] = "UNIFORM_BLOCK_ACTIVE_UNIFORMS";
    WebGLEnum[WebGLEnum["UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES"] = 35395] = "UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES";
    WebGLEnum[WebGLEnum["UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER"] = 35396] = "UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER";
    WebGLEnum[WebGLEnum["UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER"] = 35398] = "UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER";
    WebGLEnum[WebGLEnum["INVALID_INDEX"] = 4294967295] = "INVALID_INDEX";
    WebGLEnum[WebGLEnum["MAX_VERTEX_OUTPUT_COMPONENTS"] = 37154] = "MAX_VERTEX_OUTPUT_COMPONENTS";
    WebGLEnum[WebGLEnum["MAX_FRAGMENT_INPUT_COMPONENTS"] = 37157] = "MAX_FRAGMENT_INPUT_COMPONENTS";
    WebGLEnum[WebGLEnum["MAX_SERVER_WAIT_TIMEOUT"] = 37137] = "MAX_SERVER_WAIT_TIMEOUT";
    WebGLEnum[WebGLEnum["OBJECT_TYPE"] = 37138] = "OBJECT_TYPE";
    WebGLEnum[WebGLEnum["SYNC_CONDITION"] = 37139] = "SYNC_CONDITION";
    WebGLEnum[WebGLEnum["SYNC_STATUS"] = 37140] = "SYNC_STATUS";
    WebGLEnum[WebGLEnum["SYNC_FLAGS"] = 37141] = "SYNC_FLAGS";
    WebGLEnum[WebGLEnum["SYNC_FENCE"] = 37142] = "SYNC_FENCE";
    WebGLEnum[WebGLEnum["SYNC_GPU_COMMANDS_COMPLETE"] = 37143] = "SYNC_GPU_COMMANDS_COMPLETE";
    WebGLEnum[WebGLEnum["UNSIGNALED"] = 37144] = "UNSIGNALED";
    WebGLEnum[WebGLEnum["SIGNALED"] = 37145] = "SIGNALED";
    WebGLEnum[WebGLEnum["ALREADY_SIGNALED"] = 37146] = "ALREADY_SIGNALED";
    WebGLEnum[WebGLEnum["TIMEOUT_EXPIRED"] = 37147] = "TIMEOUT_EXPIRED";
    WebGLEnum[WebGLEnum["CONDITION_SATISFIED"] = 37148] = "CONDITION_SATISFIED";
    WebGLEnum[WebGLEnum["WAIT_FAILED"] = 37149] = "WAIT_FAILED";
    WebGLEnum[WebGLEnum["SYNC_FLUSH_COMMANDS_BIT"] = 1] = "SYNC_FLUSH_COMMANDS_BIT";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_DIVISOR"] = 35070] = "VERTEX_ATTRIB_ARRAY_DIVISOR";
    WebGLEnum[WebGLEnum["ANY_SAMPLES_PASSED"] = 35887] = "ANY_SAMPLES_PASSED";
    WebGLEnum[WebGLEnum["ANY_SAMPLES_PASSED_CONSERVATIVE"] = 36202] = "ANY_SAMPLES_PASSED_CONSERVATIVE";
    WebGLEnum[WebGLEnum["SAMPLER_BINDING"] = 35097] = "SAMPLER_BINDING";
    WebGLEnum[WebGLEnum["RGB10_A2UI"] = 36975] = "RGB10_A2UI";
    WebGLEnum[WebGLEnum["INT_2_10_10_10_REV"] = 36255] = "INT_2_10_10_10_REV";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK"] = 36386] = "TRANSFORM_FEEDBACK";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_PAUSED"] = 36387] = "TRANSFORM_FEEDBACK_PAUSED";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_ACTIVE"] = 36388] = "TRANSFORM_FEEDBACK_ACTIVE";
    WebGLEnum[WebGLEnum["TRANSFORM_FEEDBACK_BINDING"] = 36389] = "TRANSFORM_FEEDBACK_BINDING";
    WebGLEnum[WebGLEnum["TEXTURE_IMMUTABLE_FORMAT"] = 37167] = "TEXTURE_IMMUTABLE_FORMAT";
    WebGLEnum[WebGLEnum["MAX_ELEMENT_INDEX"] = 36203] = "MAX_ELEMENT_INDEX";
    WebGLEnum[WebGLEnum["TEXTURE_IMMUTABLE_LEVELS"] = 33503] = "TEXTURE_IMMUTABLE_LEVELS";
    WebGLEnum[WebGLEnum["MAX_CLIENT_WAIT_TIMEOUT_WEBGL"] = 37447] = "MAX_CLIENT_WAIT_TIMEOUT_WEBGL";
    WebGLEnum[WebGLEnum["DEPTH_BUFFER_BIT"] = 256] = "DEPTH_BUFFER_BIT";
    WebGLEnum[WebGLEnum["STENCIL_BUFFER_BIT"] = 1024] = "STENCIL_BUFFER_BIT";
    WebGLEnum[WebGLEnum["COLOR_BUFFER_BIT"] = 16384] = "COLOR_BUFFER_BIT";
    WebGLEnum[WebGLEnum["POINTS"] = 0] = "POINTS";
    WebGLEnum[WebGLEnum["LINES"] = 1] = "LINES";
    WebGLEnum[WebGLEnum["LINE_LOOP"] = 2] = "LINE_LOOP";
    WebGLEnum[WebGLEnum["LINE_STRIP"] = 3] = "LINE_STRIP";
    WebGLEnum[WebGLEnum["TRIANGLES"] = 4] = "TRIANGLES";
    WebGLEnum[WebGLEnum["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    WebGLEnum[WebGLEnum["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
    WebGLEnum[WebGLEnum["ZERO"] = 0] = "ZERO";
    WebGLEnum[WebGLEnum["ONE"] = 1] = "ONE";
    WebGLEnum[WebGLEnum["SRC_COLOR"] = 768] = "SRC_COLOR";
    WebGLEnum[WebGLEnum["ONE_MINUS_SRC_COLOR"] = 769] = "ONE_MINUS_SRC_COLOR";
    WebGLEnum[WebGLEnum["SRC_ALPHA"] = 770] = "SRC_ALPHA";
    WebGLEnum[WebGLEnum["ONE_MINUS_SRC_ALPHA"] = 771] = "ONE_MINUS_SRC_ALPHA";
    WebGLEnum[WebGLEnum["DST_ALPHA"] = 772] = "DST_ALPHA";
    WebGLEnum[WebGLEnum["ONE_MINUS_DST_ALPHA"] = 773] = "ONE_MINUS_DST_ALPHA";
    WebGLEnum[WebGLEnum["DST_COLOR"] = 774] = "DST_COLOR";
    WebGLEnum[WebGLEnum["ONE_MINUS_DST_COLOR"] = 775] = "ONE_MINUS_DST_COLOR";
    WebGLEnum[WebGLEnum["SRC_ALPHA_SATURATE"] = 776] = "SRC_ALPHA_SATURATE";
    WebGLEnum[WebGLEnum["FUNC_ADD"] = 32774] = "FUNC_ADD";
    WebGLEnum[WebGLEnum["FUNC_MIN"] = 32775] = "FUNC_MIN";
    WebGLEnum[WebGLEnum["FUNC_MAX"] = 32776] = "FUNC_MAX";
    WebGLEnum[WebGLEnum["BLEND_EQUATION"] = 32777] = "BLEND_EQUATION";
    WebGLEnum[WebGLEnum["BLEND_EQUATION_RGB"] = 32777] = "BLEND_EQUATION_RGB";
    WebGLEnum[WebGLEnum["BLEND_EQUATION_ALPHA"] = 34877] = "BLEND_EQUATION_ALPHA";
    WebGLEnum[WebGLEnum["FUNC_SUBTRACT"] = 32778] = "FUNC_SUBTRACT";
    WebGLEnum[WebGLEnum["FUNC_REVERSE_SUBTRACT"] = 32779] = "FUNC_REVERSE_SUBTRACT";
    WebGLEnum[WebGLEnum["BLEND_DST_RGB"] = 32968] = "BLEND_DST_RGB";
    WebGLEnum[WebGLEnum["BLEND_SRC_RGB"] = 32969] = "BLEND_SRC_RGB";
    WebGLEnum[WebGLEnum["BLEND_DST_ALPHA"] = 32970] = "BLEND_DST_ALPHA";
    WebGLEnum[WebGLEnum["BLEND_SRC_ALPHA"] = 32971] = "BLEND_SRC_ALPHA";
    WebGLEnum[WebGLEnum["CONSTANT_COLOR"] = 32769] = "CONSTANT_COLOR";
    WebGLEnum[WebGLEnum["ONE_MINUS_CONSTANT_COLOR"] = 32770] = "ONE_MINUS_CONSTANT_COLOR";
    WebGLEnum[WebGLEnum["CONSTANT_ALPHA"] = 32771] = "CONSTANT_ALPHA";
    WebGLEnum[WebGLEnum["ONE_MINUS_CONSTANT_ALPHA"] = 32772] = "ONE_MINUS_CONSTANT_ALPHA";
    WebGLEnum[WebGLEnum["BLEND_COLOR"] = 32773] = "BLEND_COLOR";
    WebGLEnum[WebGLEnum["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    WebGLEnum[WebGLEnum["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    WebGLEnum[WebGLEnum["ARRAY_BUFFER_BINDING"] = 34964] = "ARRAY_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["ELEMENT_ARRAY_BUFFER_BINDING"] = 34965] = "ELEMENT_ARRAY_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["STREAM_DRAW"] = 35040] = "STREAM_DRAW";
    WebGLEnum[WebGLEnum["STATIC_DRAW"] = 35044] = "STATIC_DRAW";
    WebGLEnum[WebGLEnum["DYNAMIC_DRAW"] = 35048] = "DYNAMIC_DRAW";
    WebGLEnum[WebGLEnum["BUFFER_SIZE"] = 34660] = "BUFFER_SIZE";
    WebGLEnum[WebGLEnum["BUFFER_USAGE"] = 34661] = "BUFFER_USAGE";
    WebGLEnum[WebGLEnum["CURRENT_VERTEX_ATTRIB"] = 34342] = "CURRENT_VERTEX_ATTRIB";
    WebGLEnum[WebGLEnum["FRONT"] = 1028] = "FRONT";
    WebGLEnum[WebGLEnum["BACK"] = 1029] = "BACK";
    WebGLEnum[WebGLEnum["FRONT_AND_BACK"] = 1032] = "FRONT_AND_BACK";
    WebGLEnum[WebGLEnum["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    WebGLEnum[WebGLEnum["CULL_FACE"] = 2884] = "CULL_FACE";
    WebGLEnum[WebGLEnum["BLEND"] = 3042] = "BLEND";
    WebGLEnum[WebGLEnum["DITHER"] = 3024] = "DITHER";
    WebGLEnum[WebGLEnum["STENCIL_TEST"] = 2960] = "STENCIL_TEST";
    WebGLEnum[WebGLEnum["DEPTH_TEST"] = 2929] = "DEPTH_TEST";
    WebGLEnum[WebGLEnum["SCISSOR_TEST"] = 3089] = "SCISSOR_TEST";
    WebGLEnum[WebGLEnum["POLYGON_OFFSET_FILL"] = 32823] = "POLYGON_OFFSET_FILL";
    WebGLEnum[WebGLEnum["SAMPLE_ALPHA_TO_COVERAGE"] = 32926] = "SAMPLE_ALPHA_TO_COVERAGE";
    WebGLEnum[WebGLEnum["SAMPLE_COVERAGE"] = 32928] = "SAMPLE_COVERAGE";
    WebGLEnum[WebGLEnum["NO_ERROR"] = 0] = "NO_ERROR";
    WebGLEnum[WebGLEnum["INVALID_ENUM"] = 1280] = "INVALID_ENUM";
    WebGLEnum[WebGLEnum["INVALID_VALUE"] = 1281] = "INVALID_VALUE";
    WebGLEnum[WebGLEnum["INVALID_OPERATION"] = 1282] = "INVALID_OPERATION";
    WebGLEnum[WebGLEnum["OUT_OF_MEMORY"] = 1285] = "OUT_OF_MEMORY";
    WebGLEnum[WebGLEnum["CW"] = 2304] = "CW";
    WebGLEnum[WebGLEnum["CCW"] = 2305] = "CCW";
    WebGLEnum[WebGLEnum["LINE_WIDTH"] = 2849] = "LINE_WIDTH";
    WebGLEnum[WebGLEnum["ALIASED_POINT_SIZE_RANGE"] = 33901] = "ALIASED_POINT_SIZE_RANGE";
    WebGLEnum[WebGLEnum["ALIASED_LINE_WIDTH_RANGE"] = 33902] = "ALIASED_LINE_WIDTH_RANGE";
    WebGLEnum[WebGLEnum["CULL_FACE_MODE"] = 2885] = "CULL_FACE_MODE";
    WebGLEnum[WebGLEnum["FRONT_FACE"] = 2886] = "FRONT_FACE";
    WebGLEnum[WebGLEnum["DEPTH_RANGE"] = 2928] = "DEPTH_RANGE";
    WebGLEnum[WebGLEnum["DEPTH_WRITEMASK"] = 2930] = "DEPTH_WRITEMASK";
    WebGLEnum[WebGLEnum["DEPTH_CLEAR_VALUE"] = 2931] = "DEPTH_CLEAR_VALUE";
    WebGLEnum[WebGLEnum["DEPTH_FUNC"] = 2932] = "DEPTH_FUNC";
    WebGLEnum[WebGLEnum["STENCIL_CLEAR_VALUE"] = 2961] = "STENCIL_CLEAR_VALUE";
    WebGLEnum[WebGLEnum["STENCIL_FUNC"] = 2962] = "STENCIL_FUNC";
    WebGLEnum[WebGLEnum["STENCIL_FAIL"] = 2964] = "STENCIL_FAIL";
    WebGLEnum[WebGLEnum["STENCIL_PASS_DEPTH_FAIL"] = 2965] = "STENCIL_PASS_DEPTH_FAIL";
    WebGLEnum[WebGLEnum["STENCIL_PASS_DEPTH_PASS"] = 2966] = "STENCIL_PASS_DEPTH_PASS";
    WebGLEnum[WebGLEnum["STENCIL_REF"] = 2967] = "STENCIL_REF";
    WebGLEnum[WebGLEnum["STENCIL_VALUE_MASK"] = 2963] = "STENCIL_VALUE_MASK";
    WebGLEnum[WebGLEnum["STENCIL_WRITEMASK"] = 2968] = "STENCIL_WRITEMASK";
    WebGLEnum[WebGLEnum["STENCIL_BACK_FUNC"] = 34816] = "STENCIL_BACK_FUNC";
    WebGLEnum[WebGLEnum["STENCIL_BACK_FAIL"] = 34817] = "STENCIL_BACK_FAIL";
    WebGLEnum[WebGLEnum["STENCIL_BACK_PASS_DEPTH_FAIL"] = 34818] = "STENCIL_BACK_PASS_DEPTH_FAIL";
    WebGLEnum[WebGLEnum["STENCIL_BACK_PASS_DEPTH_PASS"] = 34819] = "STENCIL_BACK_PASS_DEPTH_PASS";
    WebGLEnum[WebGLEnum["STENCIL_BACK_REF"] = 36003] = "STENCIL_BACK_REF";
    WebGLEnum[WebGLEnum["STENCIL_BACK_VALUE_MASK"] = 36004] = "STENCIL_BACK_VALUE_MASK";
    WebGLEnum[WebGLEnum["STENCIL_BACK_WRITEMASK"] = 36005] = "STENCIL_BACK_WRITEMASK";
    WebGLEnum[WebGLEnum["VIEWPORT"] = 2978] = "VIEWPORT";
    WebGLEnum[WebGLEnum["SCISSOR_BOX"] = 3088] = "SCISSOR_BOX";
    WebGLEnum[WebGLEnum["COLOR_CLEAR_VALUE"] = 3106] = "COLOR_CLEAR_VALUE";
    WebGLEnum[WebGLEnum["COLOR_WRITEMASK"] = 3107] = "COLOR_WRITEMASK";
    WebGLEnum[WebGLEnum["UNPACK_ALIGNMENT"] = 3317] = "UNPACK_ALIGNMENT";
    WebGLEnum[WebGLEnum["PACK_ALIGNMENT"] = 3333] = "PACK_ALIGNMENT";
    WebGLEnum[WebGLEnum["MAX_TEXTURE_SIZE"] = 3379] = "MAX_TEXTURE_SIZE";
    WebGLEnum[WebGLEnum["MAX_VIEWPORT_DIMS"] = 3386] = "MAX_VIEWPORT_DIMS";
    WebGLEnum[WebGLEnum["SUBPIXEL_BITS"] = 3408] = "SUBPIXEL_BITS";
    WebGLEnum[WebGLEnum["RED_BITS"] = 3410] = "RED_BITS";
    WebGLEnum[WebGLEnum["GREEN_BITS"] = 3411] = "GREEN_BITS";
    WebGLEnum[WebGLEnum["BLUE_BITS"] = 3412] = "BLUE_BITS";
    WebGLEnum[WebGLEnum["ALPHA_BITS"] = 3413] = "ALPHA_BITS";
    WebGLEnum[WebGLEnum["DEPTH_BITS"] = 3414] = "DEPTH_BITS";
    WebGLEnum[WebGLEnum["STENCIL_BITS"] = 3415] = "STENCIL_BITS";
    WebGLEnum[WebGLEnum["POLYGON_OFFSET_UNITS"] = 10752] = "POLYGON_OFFSET_UNITS";
    WebGLEnum[WebGLEnum["POLYGON_OFFSET_FACTOR"] = 32824] = "POLYGON_OFFSET_FACTOR";
    WebGLEnum[WebGLEnum["TEXTURE_BINDING_2D"] = 32873] = "TEXTURE_BINDING_2D";
    WebGLEnum[WebGLEnum["SAMPLE_BUFFERS"] = 32936] = "SAMPLE_BUFFERS";
    WebGLEnum[WebGLEnum["SAMPLES"] = 32937] = "SAMPLES";
    WebGLEnum[WebGLEnum["SAMPLE_COVERAGE_VALUE"] = 32938] = "SAMPLE_COVERAGE_VALUE";
    WebGLEnum[WebGLEnum["SAMPLE_COVERAGE_INVERT"] = 32939] = "SAMPLE_COVERAGE_INVERT";
    WebGLEnum[WebGLEnum["COMPRESSED_TEXTURE_FORMATS"] = 34467] = "COMPRESSED_TEXTURE_FORMATS";
    WebGLEnum[WebGLEnum["DONT_CARE"] = 4352] = "DONT_CARE";
    WebGLEnum[WebGLEnum["FASTEST"] = 4353] = "FASTEST";
    WebGLEnum[WebGLEnum["NICEST"] = 4354] = "NICEST";
    WebGLEnum[WebGLEnum["GENERATE_MIPMAP_HINT"] = 33170] = "GENERATE_MIPMAP_HINT";
    WebGLEnum[WebGLEnum["BYTE"] = 5120] = "BYTE";
    WebGLEnum[WebGLEnum["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    WebGLEnum[WebGLEnum["SHORT"] = 5122] = "SHORT";
    WebGLEnum[WebGLEnum["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    WebGLEnum[WebGLEnum["INT"] = 5124] = "INT";
    WebGLEnum[WebGLEnum["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    WebGLEnum[WebGLEnum["FLOAT"] = 5126] = "FLOAT";
    WebGLEnum[WebGLEnum["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    WebGLEnum[WebGLEnum["ALPHA"] = 6406] = "ALPHA";
    WebGLEnum[WebGLEnum["RGB"] = 6407] = "RGB";
    WebGLEnum[WebGLEnum["RGBA"] = 6408] = "RGBA";
    WebGLEnum[WebGLEnum["LUMINANCE"] = 6409] = "LUMINANCE";
    WebGLEnum[WebGLEnum["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    WebGLEnum[WebGLEnum["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    WebGLEnum[WebGLEnum["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    WebGLEnum[WebGLEnum["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    WebGLEnum[WebGLEnum["FRAGMENT_SHADER"] = 35632] = "FRAGMENT_SHADER";
    WebGLEnum[WebGLEnum["VERTEX_SHADER"] = 35633] = "VERTEX_SHADER";
    WebGLEnum[WebGLEnum["MAX_VERTEX_ATTRIBS"] = 34921] = "MAX_VERTEX_ATTRIBS";
    WebGLEnum[WebGLEnum["MAX_VERTEX_UNIFORM_VECTORS"] = 36347] = "MAX_VERTEX_UNIFORM_VECTORS";
    WebGLEnum[WebGLEnum["MAX_VARYING_VECTORS"] = 36348] = "MAX_VARYING_VECTORS";
    WebGLEnum[WebGLEnum["MAX_COMBINED_TEXTURE_IMAGE_UNITS"] = 35661] = "MAX_COMBINED_TEXTURE_IMAGE_UNITS";
    WebGLEnum[WebGLEnum["MAX_VERTEX_TEXTURE_IMAGE_UNITS"] = 35660] = "MAX_VERTEX_TEXTURE_IMAGE_UNITS";
    WebGLEnum[WebGLEnum["MAX_TEXTURE_IMAGE_UNITS"] = 34930] = "MAX_TEXTURE_IMAGE_UNITS";
    WebGLEnum[WebGLEnum["MAX_FRAGMENT_UNIFORM_VECTORS"] = 36349] = "MAX_FRAGMENT_UNIFORM_VECTORS";
    WebGLEnum[WebGLEnum["SHADER_TYPE"] = 35663] = "SHADER_TYPE";
    WebGLEnum[WebGLEnum["DELETE_STATUS"] = 35712] = "DELETE_STATUS";
    WebGLEnum[WebGLEnum["LINK_STATUS"] = 35714] = "LINK_STATUS";
    WebGLEnum[WebGLEnum["VALIDATE_STATUS"] = 35715] = "VALIDATE_STATUS";
    WebGLEnum[WebGLEnum["ATTACHED_SHADERS"] = 35717] = "ATTACHED_SHADERS";
    WebGLEnum[WebGLEnum["ACTIVE_UNIFORMS"] = 35718] = "ACTIVE_UNIFORMS";
    WebGLEnum[WebGLEnum["ACTIVE_ATTRIBUTES"] = 35721] = "ACTIVE_ATTRIBUTES";
    WebGLEnum[WebGLEnum["SHADING_LANGUAGE_VERSION"] = 35724] = "SHADING_LANGUAGE_VERSION";
    WebGLEnum[WebGLEnum["CURRENT_PROGRAM"] = 35725] = "CURRENT_PROGRAM";
    WebGLEnum[WebGLEnum["NEVER"] = 512] = "NEVER";
    WebGLEnum[WebGLEnum["LESS"] = 513] = "LESS";
    WebGLEnum[WebGLEnum["EQUAL"] = 514] = "EQUAL";
    WebGLEnum[WebGLEnum["LEQUAL"] = 515] = "LEQUAL";
    WebGLEnum[WebGLEnum["GREATER"] = 516] = "GREATER";
    WebGLEnum[WebGLEnum["NOTEQUAL"] = 517] = "NOTEQUAL";
    WebGLEnum[WebGLEnum["GEQUAL"] = 518] = "GEQUAL";
    WebGLEnum[WebGLEnum["ALWAYS"] = 519] = "ALWAYS";
    WebGLEnum[WebGLEnum["KEEP"] = 7680] = "KEEP";
    WebGLEnum[WebGLEnum["REPLACE"] = 7681] = "REPLACE";
    WebGLEnum[WebGLEnum["INCR"] = 7682] = "INCR";
    WebGLEnum[WebGLEnum["DECR"] = 7683] = "DECR";
    WebGLEnum[WebGLEnum["INVERT"] = 5386] = "INVERT";
    WebGLEnum[WebGLEnum["INCR_WRAP"] = 34055] = "INCR_WRAP";
    WebGLEnum[WebGLEnum["DECR_WRAP"] = 34056] = "DECR_WRAP";
    WebGLEnum[WebGLEnum["VENDOR"] = 7936] = "VENDOR";
    WebGLEnum[WebGLEnum["RENDERER"] = 7937] = "RENDERER";
    WebGLEnum[WebGLEnum["VERSION"] = 7938] = "VERSION";
    WebGLEnum[WebGLEnum["NEAREST"] = 9728] = "NEAREST";
    WebGLEnum[WebGLEnum["LINEAR"] = 9729] = "LINEAR";
    WebGLEnum[WebGLEnum["NEAREST_MIPMAP_NEAREST"] = 9984] = "NEAREST_MIPMAP_NEAREST";
    WebGLEnum[WebGLEnum["LINEAR_MIPMAP_NEAREST"] = 9985] = "LINEAR_MIPMAP_NEAREST";
    WebGLEnum[WebGLEnum["NEAREST_MIPMAP_LINEAR"] = 9986] = "NEAREST_MIPMAP_LINEAR";
    WebGLEnum[WebGLEnum["LINEAR_MIPMAP_LINEAR"] = 9987] = "LINEAR_MIPMAP_LINEAR";
    WebGLEnum[WebGLEnum["TEXTURE_MAG_FILTER"] = 10240] = "TEXTURE_MAG_FILTER";
    WebGLEnum[WebGLEnum["TEXTURE_MIN_FILTER"] = 10241] = "TEXTURE_MIN_FILTER";
    WebGLEnum[WebGLEnum["TEXTURE_WRAP_S"] = 10242] = "TEXTURE_WRAP_S";
    WebGLEnum[WebGLEnum["TEXTURE_WRAP_T"] = 10243] = "TEXTURE_WRAP_T";
    WebGLEnum[WebGLEnum["TEXTURE"] = 5890] = "TEXTURE";
    WebGLEnum[WebGLEnum["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    WebGLEnum[WebGLEnum["TEXTURE_BINDING_CUBE_MAP"] = 34068] = "TEXTURE_BINDING_CUBE_MAP";
    WebGLEnum[WebGLEnum["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    WebGLEnum[WebGLEnum["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    WebGLEnum[WebGLEnum["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    WebGLEnum[WebGLEnum["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    WebGLEnum[WebGLEnum["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    WebGLEnum[WebGLEnum["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
    WebGLEnum[WebGLEnum["MAX_CUBE_MAP_TEXTURE_SIZE"] = 34076] = "MAX_CUBE_MAP_TEXTURE_SIZE";
    WebGLEnum[WebGLEnum["TEXTURE0"] = 33984] = "TEXTURE0";
    WebGLEnum[WebGLEnum["TEXTURE1"] = 33985] = "TEXTURE1";
    WebGLEnum[WebGLEnum["TEXTURE2"] = 33986] = "TEXTURE2";
    WebGLEnum[WebGLEnum["TEXTURE3"] = 33987] = "TEXTURE3";
    WebGLEnum[WebGLEnum["TEXTURE4"] = 33988] = "TEXTURE4";
    WebGLEnum[WebGLEnum["TEXTURE5"] = 33989] = "TEXTURE5";
    WebGLEnum[WebGLEnum["TEXTURE6"] = 33990] = "TEXTURE6";
    WebGLEnum[WebGLEnum["TEXTURE7"] = 33991] = "TEXTURE7";
    WebGLEnum[WebGLEnum["TEXTURE8"] = 33992] = "TEXTURE8";
    WebGLEnum[WebGLEnum["TEXTURE9"] = 33993] = "TEXTURE9";
    WebGLEnum[WebGLEnum["TEXTURE10"] = 33994] = "TEXTURE10";
    WebGLEnum[WebGLEnum["TEXTURE11"] = 33995] = "TEXTURE11";
    WebGLEnum[WebGLEnum["TEXTURE12"] = 33996] = "TEXTURE12";
    WebGLEnum[WebGLEnum["TEXTURE13"] = 33997] = "TEXTURE13";
    WebGLEnum[WebGLEnum["TEXTURE14"] = 33998] = "TEXTURE14";
    WebGLEnum[WebGLEnum["TEXTURE15"] = 33999] = "TEXTURE15";
    WebGLEnum[WebGLEnum["TEXTURE16"] = 34000] = "TEXTURE16";
    WebGLEnum[WebGLEnum["TEXTURE17"] = 34001] = "TEXTURE17";
    WebGLEnum[WebGLEnum["TEXTURE18"] = 34002] = "TEXTURE18";
    WebGLEnum[WebGLEnum["TEXTURE19"] = 34003] = "TEXTURE19";
    WebGLEnum[WebGLEnum["TEXTURE20"] = 34004] = "TEXTURE20";
    WebGLEnum[WebGLEnum["TEXTURE21"] = 34005] = "TEXTURE21";
    WebGLEnum[WebGLEnum["TEXTURE22"] = 34006] = "TEXTURE22";
    WebGLEnum[WebGLEnum["TEXTURE23"] = 34007] = "TEXTURE23";
    WebGLEnum[WebGLEnum["TEXTURE24"] = 34008] = "TEXTURE24";
    WebGLEnum[WebGLEnum["TEXTURE25"] = 34009] = "TEXTURE25";
    WebGLEnum[WebGLEnum["TEXTURE26"] = 34010] = "TEXTURE26";
    WebGLEnum[WebGLEnum["TEXTURE27"] = 34011] = "TEXTURE27";
    WebGLEnum[WebGLEnum["TEXTURE28"] = 34012] = "TEXTURE28";
    WebGLEnum[WebGLEnum["TEXTURE29"] = 34013] = "TEXTURE29";
    WebGLEnum[WebGLEnum["TEXTURE30"] = 34014] = "TEXTURE30";
    WebGLEnum[WebGLEnum["TEXTURE31"] = 34015] = "TEXTURE31";
    WebGLEnum[WebGLEnum["ACTIVE_TEXTURE"] = 34016] = "ACTIVE_TEXTURE";
    WebGLEnum[WebGLEnum["REPEAT"] = 10497] = "REPEAT";
    WebGLEnum[WebGLEnum["CLAMP_TO_EDGE"] = 33071] = "CLAMP_TO_EDGE";
    WebGLEnum[WebGLEnum["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
    WebGLEnum[WebGLEnum["FLOAT_VEC2"] = 35664] = "FLOAT_VEC2";
    WebGLEnum[WebGLEnum["FLOAT_VEC3"] = 35665] = "FLOAT_VEC3";
    WebGLEnum[WebGLEnum["FLOAT_VEC4"] = 35666] = "FLOAT_VEC4";
    WebGLEnum[WebGLEnum["INT_VEC2"] = 35667] = "INT_VEC2";
    WebGLEnum[WebGLEnum["INT_VEC3"] = 35668] = "INT_VEC3";
    WebGLEnum[WebGLEnum["INT_VEC4"] = 35669] = "INT_VEC4";
    WebGLEnum[WebGLEnum["BOOL"] = 35670] = "BOOL";
    WebGLEnum[WebGLEnum["BOOL_VEC2"] = 35671] = "BOOL_VEC2";
    WebGLEnum[WebGLEnum["BOOL_VEC3"] = 35672] = "BOOL_VEC3";
    WebGLEnum[WebGLEnum["BOOL_VEC4"] = 35673] = "BOOL_VEC4";
    WebGLEnum[WebGLEnum["FLOAT_MAT2"] = 35674] = "FLOAT_MAT2";
    WebGLEnum[WebGLEnum["FLOAT_MAT3"] = 35675] = "FLOAT_MAT3";
    WebGLEnum[WebGLEnum["FLOAT_MAT4"] = 35676] = "FLOAT_MAT4";
    WebGLEnum[WebGLEnum["SAMPLER_2D"] = 35678] = "SAMPLER_2D";
    WebGLEnum[WebGLEnum["SAMPLER_CUBE"] = 35680] = "SAMPLER_CUBE";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_ENABLED"] = 34338] = "VERTEX_ATTRIB_ARRAY_ENABLED";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_SIZE"] = 34339] = "VERTEX_ATTRIB_ARRAY_SIZE";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_STRIDE"] = 34340] = "VERTEX_ATTRIB_ARRAY_STRIDE";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_TYPE"] = 34341] = "VERTEX_ATTRIB_ARRAY_TYPE";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_NORMALIZED"] = 34922] = "VERTEX_ATTRIB_ARRAY_NORMALIZED";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_POINTER"] = 34373] = "VERTEX_ATTRIB_ARRAY_POINTER";
    WebGLEnum[WebGLEnum["VERTEX_ATTRIB_ARRAY_BUFFER_BINDING"] = 34975] = "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING";
    WebGLEnum[WebGLEnum["IMPLEMENTATION_COLOR_READ_TYPE"] = 35738] = "IMPLEMENTATION_COLOR_READ_TYPE";
    WebGLEnum[WebGLEnum["IMPLEMENTATION_COLOR_READ_FORMAT"] = 35739] = "IMPLEMENTATION_COLOR_READ_FORMAT";
    WebGLEnum[WebGLEnum["COMPILE_STATUS"] = 35713] = "COMPILE_STATUS";
    WebGLEnum[WebGLEnum["LOW_FLOAT"] = 36336] = "LOW_FLOAT";
    WebGLEnum[WebGLEnum["MEDIUM_FLOAT"] = 36337] = "MEDIUM_FLOAT";
    WebGLEnum[WebGLEnum["HIGH_FLOAT"] = 36338] = "HIGH_FLOAT";
    WebGLEnum[WebGLEnum["LOW_INT"] = 36339] = "LOW_INT";
    WebGLEnum[WebGLEnum["MEDIUM_INT"] = 36340] = "MEDIUM_INT";
    WebGLEnum[WebGLEnum["HIGH_INT"] = 36341] = "HIGH_INT";
    WebGLEnum[WebGLEnum["FRAMEBUFFER"] = 36160] = "FRAMEBUFFER";
    WebGLEnum[WebGLEnum["RENDERBUFFER"] = 36161] = "RENDERBUFFER";
    WebGLEnum[WebGLEnum["RGBA4"] = 32854] = "RGBA4";
    WebGLEnum[WebGLEnum["RGB5_A1"] = 32855] = "RGB5_A1";
    WebGLEnum[WebGLEnum["RGB565"] = 36194] = "RGB565";
    WebGLEnum[WebGLEnum["DEPTH_COMPONENT16"] = 33189] = "DEPTH_COMPONENT16";
    WebGLEnum[WebGLEnum["STENCIL_INDEX8"] = 36168] = "STENCIL_INDEX8";
    WebGLEnum[WebGLEnum["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
    WebGLEnum[WebGLEnum["RENDERBUFFER_WIDTH"] = 36162] = "RENDERBUFFER_WIDTH";
    WebGLEnum[WebGLEnum["RENDERBUFFER_HEIGHT"] = 36163] = "RENDERBUFFER_HEIGHT";
    WebGLEnum[WebGLEnum["RENDERBUFFER_INTERNAL_FORMAT"] = 36164] = "RENDERBUFFER_INTERNAL_FORMAT";
    WebGLEnum[WebGLEnum["RENDERBUFFER_RED_SIZE"] = 36176] = "RENDERBUFFER_RED_SIZE";
    WebGLEnum[WebGLEnum["RENDERBUFFER_GREEN_SIZE"] = 36177] = "RENDERBUFFER_GREEN_SIZE";
    WebGLEnum[WebGLEnum["RENDERBUFFER_BLUE_SIZE"] = 36178] = "RENDERBUFFER_BLUE_SIZE";
    WebGLEnum[WebGLEnum["RENDERBUFFER_ALPHA_SIZE"] = 36179] = "RENDERBUFFER_ALPHA_SIZE";
    WebGLEnum[WebGLEnum["RENDERBUFFER_DEPTH_SIZE"] = 36180] = "RENDERBUFFER_DEPTH_SIZE";
    WebGLEnum[WebGLEnum["RENDERBUFFER_STENCIL_SIZE"] = 36181] = "RENDERBUFFER_STENCIL_SIZE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE"] = 36048] = "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_OBJECT_NAME"] = 36049] = "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL"] = 36050] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE"] = 36051] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE";
    WebGLEnum[WebGLEnum["COLOR_ATTACHMENT0"] = 36064] = "COLOR_ATTACHMENT0";
    WebGLEnum[WebGLEnum["DEPTH_ATTACHMENT"] = 36096] = "DEPTH_ATTACHMENT";
    WebGLEnum[WebGLEnum["STENCIL_ATTACHMENT"] = 36128] = "STENCIL_ATTACHMENT";
    WebGLEnum[WebGLEnum["DEPTH_STENCIL_ATTACHMENT"] = 33306] = "DEPTH_STENCIL_ATTACHMENT";
    WebGLEnum[WebGLEnum["NONE"] = 0] = "NONE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_COMPLETE"] = 36053] = "FRAMEBUFFER_COMPLETE";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_INCOMPLETE_ATTACHMENT"] = 36054] = "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT"] = 36055] = "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_INCOMPLETE_DIMENSIONS"] = 36057] = "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_UNSUPPORTED"] = 36061] = "FRAMEBUFFER_UNSUPPORTED";
    WebGLEnum[WebGLEnum["FRAMEBUFFER_BINDING"] = 36006] = "FRAMEBUFFER_BINDING";
    WebGLEnum[WebGLEnum["RENDERBUFFER_BINDING"] = 36007] = "RENDERBUFFER_BINDING";
    WebGLEnum[WebGLEnum["MAX_RENDERBUFFER_SIZE"] = 34024] = "MAX_RENDERBUFFER_SIZE";
    WebGLEnum[WebGLEnum["INVALID_FRAMEBUFFER_OPERATION"] = 1286] = "INVALID_FRAMEBUFFER_OPERATION";
    WebGLEnum[WebGLEnum["UNPACK_FLIP_Y_WEBGL"] = 37440] = "UNPACK_FLIP_Y_WEBGL";
    WebGLEnum[WebGLEnum["UNPACK_PREMULTIPLY_ALPHA_WEBGL"] = 37441] = "UNPACK_PREMULTIPLY_ALPHA_WEBGL";
    WebGLEnum[WebGLEnum["CONTEXT_LOST_WEBGL"] = 37442] = "CONTEXT_LOST_WEBGL";
    WebGLEnum[WebGLEnum["UNPACK_COLORSPACE_CONVERSION_WEBGL"] = 37443] = "UNPACK_COLORSPACE_CONVERSION_WEBGL";
    WebGLEnum[WebGLEnum["BROWSER_DEFAULT_WEBGL"] = 37444] = "BROWSER_DEFAULT_WEBGL";
    WebGLEnum[WebGLEnum["TEXTURE_MAX_ANISOTROPY"] = 34046] = "TEXTURE_MAX_ANISOTROPY";
    WebGLEnum[WebGLEnum["MAX_TEXTURE_MAX_ANISOTROPY"] = 34047] = "MAX_TEXTURE_MAX_ANISOTROPY";
    return WebGLEnum;
}({});

export { WebGLEnum };
//# sourceMappingURL=webgl_enum.js.map
